import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { getInvoiceProperty } from 'invoices-ui-lib/utils/property';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const NextReminderDate = ({
  invoice,
  isPollingForNextReminderDate
}) => {
  const upcomingReminderDates = getInvoiceProperty(invoice, 'hs_upcoming_reminder_dates');
  const nextReminderDate = !!upcomingReminderDates && upcomingReminderDates.split(';').length > 0 && upcomingReminderDates.split(';')[0];
  if (!nextReminderDate) {
    return null;
  }
  if (isPollingForNextReminderDate) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      size: "xs"
    });
  }
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "invoice-next-reminder-date",
    marginBlockEnd: "100",
    as: "div",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoicesHighlightCard.details.nextReminderDate",
      options: {
        dateTime: I18n.moment.portalTz(+nextReminderDate).format('LL')
      }
    })
  });
};
export default NextReminderDate;